import { useState } from "react";
import { ReactSVG } from "react-svg";
import useWindowSize from "Hooks/useWindowSize";
import { MedGroups } from "JSON/BESTPHARMA";
import { MedObjects } from "Components/Pharmacy/MedObjects";
import { MedicamentsGroup } from "Components/Modals/Pharmacy/MedicamentsGroup";
import { PharmacyLocation } from "Components/Modals/Pharmacy/PharmacyLocation";
import { PharmacyContact } from "Components/Modals/Pharmacy/PharmacyContact";
import { Link } from "react-router-dom";
import { BasicBreadcrumbs } from "Components/Breadcrumbs/Breadcrumbs";
import { useGetUserQuery } from "Reducers/ApiSlice";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import CareCard from "Components/Cards/CareCard";
import {
    babyCareData1,
    // babyCareData2,
    cardsList,
    daysList,
    medicalTechnicsData,
    cosmeticsData,
    medicineCardsData,
    hygieneProductsData,
    bodyCareProducts,
  } from "JSON/PHARMHOUSE";
import MedicalTechniqueCard from "Components/Cards/MedicalTechniqueCard";
import CosmeticsCard from "Components/Cards/CosmeticsCard";
import TitleDescription from "Components/TitleDescription/TitleDescription";
import FaceCareSection from "Components/Pharmacy/FaceCareSection";

export const PharmHouse = () => {
  const { width } = useWindowSize();

  const { error } = useGetUserQuery();

  const [showAllHygieneProds, setShowAllHygieneProds] = useState(true)
  const [showAllBabyProds, setShowAllBabyProds] = useState(true)
  const [showAllCosmeticsProds, setShowAllCosmeticsProds] = useState(true)
  const [showAllBodyCareProds, setShowAllBodyCareProds] = useState(true)

  return (
    <div>
        <section className="relative">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <BasicBreadcrumbs
                    breadcrumbs={[
                    {
                        title: "აფთიაქები",
                        link: "/clinics/aptiakebi",
                    },
                    {
                        title: "ფარმ სახლი",
                        link: "/",
                    },
                    ]}
                />
                <div className="flex sm:px-[16px] mt-[74px] xl:flex-col gap-4">
                    <div className="flex">
                        <div>
                            <div className="">
                                <img 
                                    src={width > 833 ? "/images/pharmacy/pharmaHouse/pharmHouse.png" : "/images/pharmacy/pharmaHouse/pharmHouseMobile.png"}
                                    // src={"/images/pharmacy/pharmaHouse/pharmHouse.png"}
                                    alt='Pharm-House'
                                    className="hidden md:block md:w-full md:mb-[20px]"
                                />
                            </div>
                            <TitleDescription
                                title="ფარმ სახლი"
                                description="სააფთიაქო ქსელი „ფარმსახლი“ 2007 წლიდან ოპერირებს ქართულ ფარმაცევტულ ბაზარზე და ქმნის უნიკალურ, ინოვაციურ მომსახურებას მომხმარებლებისთვის. ფარმსახლი პირველი სააფთიაქო ქსელია ამიერკავკასიაში, რომელმაც მომხმარებელს სააფთიაქო რობოტის მომსახურება შესთავაზა. ფარმსახლის აფთიაქებში დაგხდებათ უმაღლესი ხარისხის, წამყვანი ბრენდების მედიკამენტების, სამედიცინო ტექნიკის და სამკურნალო კოსმეტიკის მრავალფეროვანი არჩევანი."
                                withoutStar
                                contentStyles={`sm:!px-0 ${width > 2000 && width < 2500 && "w-[1200px]"}`}
                                descriptionStyles={`text-[16px] leading-[24px] mr-[20px] sm:mr-0`}
                            />
                            <div className="flex items-center mt-[12px] mb-[20px] pb-[12px] border-b w-[124px] border-blackPrimary-10">
                                <img
                                    width={24}
                                    height={24}
                                    src="/images/pharmacy/pharmaHouse/Phone.svg"
                                    alt="telephone"
                                />
                                <h3 className="text-raspberry-100 leading-[21px] text-[14px] font-semibold">0322 47 01 10</h3>
                            </div>
                            <p className="mb-5 font-medium text-lightgray text-[14px] leading-[21px]">ფარმსახლის აფთიაქების ქსელში VITA ბარათის ფასდაკლებების მისაღებად <span className="text-raspberry-100 leading-[21px] text-[14px] font-semibold">აუცილებელია ფარმსახლის სკა ბარათის ქონაც.</span></p>
                            <div className="flex items-center">
                                <img
                                    src="/images/pharmacy/pharmaHouse/skaCard.png"
                                    alt="ska"
                                    width={191}
                                    height={126}
                                />
                                <p className="mb-5 font-medium text-lightgray text-[14px] leading-[21px] w-[261px] ml-[12px]">სკა ბარათის გახსნა შესაძლებელია ადგილზე, ფილიალში.</p>
                            </div>
                        </div>
                        <div className="pl-[40px]xl:pl-[0px] md:hidden">
                            <img 
                                src="/images/pharmacy/pharmaHouse/pharmHouse.png"
                                alt='Pharm-House'
                                width={"1120px"}
                                className={`mt-[64px] static ${width > 2000 && "absolute w-[500px] right-[50px]"} ${width > 3000 && "absolute w-[700px] right-[50px]"}`}
                            />
                            <img 
                                src="/images/pharmacy/pharmaHouse/greenBg.png"
                                alt='Pharm-House'
                                width={360}
                                className={`absolute block lg:w-[200px] xl:w-[250px] 2xl:w-[300px] -z-10 top-[100px] lg:top-[130px] xl:top-[120px] right-0 ${width > 2000 && width < 3000 && "w-[450px] right-0"} ${width > 3000 && "w-[600px] right-0"}`}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <section className="pt-[86px] pb-[80px] sm:py-[4px]">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="ბავშვის მოვლა"
                    description="მუდმივმოქმედი, 35% ფასდაკლება მოცემული ბრენდების სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                    percentage={35}
                />
            </div>
            <div className={`flex lg:block ${width > 2600 && "justify-center"}`}>
                {(width > 1560 || width < 640) &&
                    <img
                        src="/images/pharmacy/pharmaHouse/babyImg.png"
                        alt="baby"
                        className={`max-h-[470px] sm:mb-[32px] max-w-[400px] w-full md:w-[300px] ${width > 2600 && "absolute left-0 max-h-[534px] max-w-[430px]"}`}
                    />
                }
                
                <div
                    className={`grid ${width > 1801 && "grid-cols-5 ml-[-24px]"} ${width > 1560 && width < 1801 && "mr-[24px]"} ${width < 1561 && "!px-[40px] w-full sm:!px-[20px] md:!px-[16px]"} mt-[32px] gap-y-[20px] gap-x-[30px] grid-cols-4 sm:grid-cols-1 md:grid-cols-2 justify-between lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 w-full xl:justify-between xl:w-full 2xl:!w-full 2xl:justify-between 2xl:ml-0 xl:px-[20px] 2xl:px-[20px] ${width > 2000 && "max-w-[1760px] w-full"}`}
                >
                    {babyCareData1.map(item => {
                        return(
                            <CareCard data={item}
                                style={`
                                        ${item.id === 5 && width > 1801 && "col-start-3 sm:w-[343px] h-[194px]"}
                                        ${item.id === 5 && width > 1560 && width < 1801 && "col-start-2 !grid-cols-4 ml-0 sm:w-[343px] h-[194px]"}
                                        ${(item.id === 5 || item.id === 6 || item.id === 7) && width > 1801 && "ml-[-180px] w-full h-[194px] min-h-[194px] h-full"}
                                        ${width < 1561 && !!showAllBabyProds && item.id > 4 && "hidden"}
                                        ${width < 1561 && "!w-full"}
                                        ${width < 1281 && "!w-full"}
                                        ${width < 1281 && !!showAllBabyProds && item.id > 3 && "hidden"}
                                        ${width < 833 && !!showAllBabyProds && item.id > 2 && "hidden"}
                                        ${width < 833 && "!w-full"}
                                        ${width > 2000 && "max-w-[343px] w-full max-h-[194px] h-full"}
                                    `}
                            />
                        )
                    })}
                </div>

            </div>
            {width < 1560 && 
                <div className="flex sm:justify-center justify-end pr-[2.8%] sm:pr-0 md:pr-[2.5%] lg:pr-[4.2%] xl:pr-[3.2%] w-full pt-[20px]">
                    <button
                        className="flex justify-center bg-raspberry-100 py-[10px] px-[20px] rounded-[12px] text-[#fff] font-semibold leading-[21px]"
                        onClick={() => setShowAllBabyProds((prev) => !prev)}
                    >
                        {!!showAllBabyProds ? "იხილე ყველა" : "იხილე ნაკლები"}
                    </button>
                </div>
            }
        </section>

        <section className="mt-[0px] sm:mt-[40px]">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="ფასდაკლება მედიკამენტებზე"
                    description="VITA ბარათით კვირის ნებისმიერ დღეს ფასდაკლებით შეიძენთ ყველა იმ მედიკამენტს, რომელზეც ფარმ სახლში ფასდაკლება ვრცელდება მხოლოდ სააქციო დღეებში"
                    description1="ფასდაკლების დღეები ვიტა ბარათის მფლობელებს"
                    percentageUntil={50}
                />

                {
                    width > 640 ? 
                        <div className="flex flex-wrap gap-y-[30px] sm:gap-[8px] sm:gap-x-[8px] md:gap-[10px] 2xl:gap-x-[30px] items-center justify-between sm:w-full sm:justify-between 2xl:justify-start mb-[50px]">
                            <Swiper
                                spaceBetween={12}
                                modules={[Navigation]}
                                navigation
                                breakpoints={{
                                200: {
                                    slidesPerView: 1.2,
                                },
                                600: {
                                    slidesPerView: 2.9,
                                },
                                832: {
                                    slidesPerView: 3.9,
                                },
                                1080: {
                                    slidesPerView: 5.1,
                                },
                                1280: {
                                    slidesPerView: 6.2,
                                },
                                1527: {
                                    slidesPerView: 7,
                                },
                                }}
                                className={`${
                                width > 1527 ? "" : ""
                                } w-full`}
                            >
                                {daysList?.map((item, i) => {
                                return (
                                    <SwiperSlide
                                    key={i}
                                    className="w-full flex justify-between bg-[#fff] rounded-[12px] p-[12px] border border-blackPrimary-10"
                                    >
                                    <div className="flex flex-col gap-0">
                                        <h2
                                        className={`${
                                            item.isVita
                                            ? "text-raspberry-100"
                                            : "text-blackPrimary-60"
                                        } text-rg mb-0 font-bold`}
                                        >
                                        {item.day}
                                        </h2>
                                        <span
                                        className={`${
                                            item.isVita
                                            ? "text-raspberry-100"
                                            : "text-blackPrimary-60"
                                        } text-sm font-regular`}
                                        >
                                        ფასდაკლების დღე
                                        </span>
                                    </div>
                                    <img
                                        className="min-w-[30px] min-h-[30px]"
                                        width={30}
                                        height={30}
                                        src={item.img}
                                        alt="vita"
                                    />
                                    </SwiperSlide>
                                );
                                })}
                            </Swiper>
                        </div>
                    :
                        <div className={`grid grid-cols-2 ${width < 390 && "sm:grid-cols-1 w-full"} gap-y-[30px] sm:gap-[8px] sm:gap-x-[8px] md:gap-[10px] 2xl:gap-x-[30px] items-center justify-between sm:w-full sm:justify-between 2xl:justify-start mb-[50px] px-[16px]`}>
                            {daysList?.map((item, i) => {
                                return (
                                <div
                                    key={i}
                                    className={`flex justify-between sm:w-full sm:h-[60px] items-center bg-[#fff] rounded-[12px] p-[12px] sm:p-[8px] border border-blackPrimary-10 ${width < 388 && "!w-full"}`}
                                >
                                    <div className="flex flex-col gap-0">
                                    <h2
                                        className={`${
                                        item.isVita
                                            ? "text-raspberry-100"
                                            : "text-blackPrimary-60"
                                        } text-[14px] leading-[21px] mb-0 font-bold`}
                                    >
                                        {item.day}
                                    </h2>
                                    <span
                                        className={`text-[12px] leading-[18px] ${
                                        item.isVita
                                            ? "text-raspberry-100"
                                            : "text-blackPrimary-60"
                                        } font-regular w-full`}
                                    >
                                        ფასდაკლების დღე
                                    </span>
                                    </div>
                                    <img
                                    className="min-w-[30px] max-h-[30px] sm:min-h-[20px] sm:max-h-[20px]"
                                    src={item.img}
                                    alt="vita"
                                    />
                                </div>
                                );
                            })}
                        </div>
                }


                <Swiper
                    spaceBetween={width < 640 ? 12 : 32}
                    modules={[Navigation]}
                    navigation
                    breakpoints={{
                        200: {
                        slidesPerView: 1.2,
                        },
                        300: {
                        slidesPerView: 1.7,
                        },
                        500: {
                        slidesPerView: 2.8,
                        },
                        600: {
                        slidesPerView: 2.4,
                        },
                        832: {
                        slidesPerView: 3.2,
                        },
                        1080: {
                        slidesPerView: 4.4,
                        },
                        1280: {
                        slidesPerView: 5,
                        },
                        1527: {
                        slidesPerView: 5,
                        },
                    }}
                    className={`${width > 1527 ? "" : "pr-0 pl-0 sm:pr-0 sm:pl-0"} md:px-[0px] w-full`}
                >
                    {cardsList?.map((item, i) => {
                        return (
                            <SwiperSlide
                                key={i}
                            >
                                <img
                                    width={282}
                                    height={140}
                                    src={item.img}
                                    key={item.id}
                                    alt={item.img}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                <div className="relative mt-[100px] sm:mt-[40px] mb-[64px] sm:mb-[20px] sm:border-[4px] border-[#EDB937] min-h-[240px] bg-[#EDB93733] h-full w-full rounded-[36px]">
                    <img
                        className="absolute block 2xl:hidden right-[-2px] top-[-2px]"
                        src="/images/pharmacy/pharmaHouse/vector.svg"
                        alt=""
                    />
                    <div className="flex lg:block">
                        <div className="relative flex lg:hidden items-end w-full max-w-[486px] max-h-[500px]">
                            <img
                                src="/images/pharmacy/pharmaHouse/family.png"
                                alt="bg"
                                className="rounded-bl-[36px]"
                            />
                        </div>
                        <div className="flex flex-col justify-center p-[16px] md:p-[16px]">
                            <TitleDescription
                                title={`${"ვიტამინები და საკვები დანამტები მთელი ოჯახისთვის".toUpperCase()}`}
                                description="მუდმივმოქმედი, 35% ფასდაკლება WALMARK ბრენდების სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                                percentage={35}
                                headerStyles={"text-[24px] leading-[36px] sm:text-[12px] sm:leading-[18px] font-bold"}
                                contentStyles="sm:!px-0"
                            />
                            <div>
                                <img
                                    src="/images/pharmacy/pharmaHouse/walmark.svg"
                                    alt="sale"
                                    className="sm:w-[103px] sm:h-[24px] xl:w-[175px] xl:h-[41px]"
                                />
                            </div>
                        </div>
                        <div className="relative hidden lg:flex items-end w-full max-w-[486px] max-h-[500px]">
                            <img
                                src="/images/pharmacy/pharmaHouse/family.png"
                                alt="bg"
                                className="rounded-bl-[36px]"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="relative">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="B.WELL-ის სამედიცინო ტექნიკა"
                    description="მუდმივმოქმედი, 35% ფასდაკლება სამედიცინო ტექნიკის სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                    percentage={35}
                />
                <div className="flex justify-between sm:pl-[16px]">

                    <Swiper
                        modules={[Navigation]}
                        navigation
                        spaceBetween={width < 640 ? 12 : 20}
                        breakpoints={{
                            0: {
                            slidesPerView: 1,
                            },
                            100: {
                            slidesPerView: 1.1,
                            },
                            200: {
                            slidesPerView: 1.5,
                            },
                            300: {
                            slidesPerView: 1.8,
                            },
                            400: {
                            slidesPerView: 2.0,
                            },
                            450: {
                            slidesPerView: 2.2,
                            },
                            540: {
                            slidesPerView: 2.5,
                            },
                            600: {
                            slidesPerView: 2.9,
                            },
                            750: {
                            slidesPerView: 3.2,
                            },
                            832: {
                            slidesPerView: 3.8,
                            },
                            950: {
                            slidesPerView: 4.3,
                            },
                            1080: {
                            slidesPerView: 4.5,
                            },
                            1180: {
                            slidesPerView: 4.8,
                            },
                            1280: {
                            slidesPerView: 5.7,
                            },
                            1530: {
                            slidesPerView: 6,
                            },
                            1601: {
                            slidesPerView: 5,
                            },
                        }}
                    >
                        {/* <div className="flex gap-x-[30px]"> */}
                            {medicalTechnicsData.map(item => {
                                return(
                                    <SwiperSlide key={item.id} className="flex">
                                        <MedicalTechniqueCard data={item} />
                                    </SwiperSlide>
                                )
                            })}
                            <SwiperSlide className={`"hidden ${width < 1601 && "block"}`}>
                                <img
                                    src="/images/pharmacy/pharmaHouse/bwellResponsive.png"
                                    alt="bwell"
                                    className={`h-full ${width > 1601 && "hidden"}`}
                                />
                            </SwiperSlide>
                        {/* </div> */}
                    </Swiper>
                    <img
                        src="/images/pharmacy/pharmaHouse/bwell.png"
                        alt="bwell"
                        className={`ml-[20px] block ${width < 1601 && "hidden"} max-w-[480px]`}
                    />
                </div>

            </div>             
        </section>

        <section className="mt-[0px] sm:mt-[48px]">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="სახის მოვლის საშუალებები"
                    percentage={35}
                />

                <FaceCareSection />
            </div>
        </section>

        <section className="mt-[96px] sm:mt-[40px]">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="BIONIKE დეკორატიული კოსმეტიკა"
                    description="მუდმივმოქმედი, 35% ფასდაკლება დეკორატიული კოსმეტიკის სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                    percentage={35}
                />
            </div>
            <div className={`${width > 2000 && "flex justify-center"}`}>
                <div className={`grid grid-cols-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-[30px] mx-[40px] sm:mx-auto md:mx-auto lg:mx-auto xl:mx-auto 2xl:mx-auto justify-between items-center ${width > 1876 && "!max-w-[88%]"} 2xl:w-[95%] ${width > 2000 && "!w-[1760px]"}`}>
                    {cosmeticsData?.map(item => (
                            <CosmeticsCard
                                data={item}
                                style={`${width < 1641 && "!w-full"}
                                        ${item.id === 7 && width > 1641 && "col-start-2 sm:w-[343px]"}
                                        ${(item.id === 7 || item.id === 8 || item.id === 9 || item.id === 10 || item.id === 11) && width > 1641 && "ml-[-80px]"}
                                        ${!!showAllCosmeticsProds && item.id > 6 && `${width < 1641 && "hidden"}`}
                                        ${!!showAllCosmeticsProds && item.id > 5 && "2xl:hidden"}
                                        ${!!showAllCosmeticsProds && item.id > 4 && "xl:hidden"}
                                        ${!!showAllCosmeticsProds && item.id > 3 && "lg:hidden"}
                                        ${!!showAllCosmeticsProds && item.id > 2 && "md:hidden"}
                                        ${!!showAllCosmeticsProds && item.id > 1 && "sm:hidden"}
                                    `
                                }
                            />
                        )
                    )}
                </div>
            </div>

            {width < 1641 && 
                <div className="pr-[2.5%] sm:pr-0 flex justify-end sm:justify-center w-full pt-[20px]">
                    <button
                        className="flex justify-center bg-raspberry-100 py-[10px] px-[20px] rounded-[12px] text-[#fff] font-semibold leading-[21px]"
                        onClick={() => setShowAllCosmeticsProds((prev) => !prev)}
                    >
                        {!!showAllCosmeticsProds ? "იხილე ყველა" : "იხილე ნაკლები"}
                    </button>
                </div>
            }
        </section>

        <section className={`mt-[96px] sm:mt-[40px]`}>
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="თმის მოვლის საშუალებები"
                    description="მუდმივმოქმედი, 35% ფასდაკლება მოცემული ბრენდების სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                    percentage={35}
                />
            </div>

            <div className={`${width > 2000 && "flex justify-center items-center relative"}`}>
                <div className={`flex items-center sm:flex-col justify-between ${width > 2000 && "!justify-center"}`}>
                    <div className={`flex-0 min-w-[370px] lg:hidden sm:block sm:w-full sm:ml-[-20px] sm:pb-[32px] xl:ml-[-100px] ${width > 2000 && "absolute top-[-30px] left-0"} ${width > 2500 && "absolute top-[-80px] left-0"}`}>
                        <img
                            src={"/images/pharmacy/pharmaHouse/girl.png"}
                            alt=""
                            className={``}
                        />
                    </div>

                        <div className={`flex gap-[10px] max-w-[1530px] flex-1 sm:flex-col md:flex-col justify-start lg:justify-around items-center gap-x-[30px] xl:gap-x-[20px] 2xl:gap-x-[10px] ml-[-100px] sm:ml-0 md:ml-0 lg:ml-0 xl:ml-0 2xl:ml-0 pr-[100px] sm:pr-0 md:pr-0 lg:pr-0 xl:pr-0 2xl:pr-0 ${width > 2000 && "container w-full !m-0 !p-0"}`}>
                            <div className={`flex justify-around lg:w-full lg:justify-between lg:px-[16px] ${width > 1500 && width < 2500 && "w-full !w-[960px] !justify-between"} ${width > 2500 && "!w-[1530px] !justify-between"}`}>
                                <div className="relative h-full max-h-[305px] w-[288px] sm:w-[168px] md:w-[210px] lg:w-[250px] xl:w-[270px] 2xl:w-[270px]">
                                    <img
                                        src="/images/pharmacy/pharmaHouse/yellowRectangle1.png"
                                        alt=""
                                    />
                                    <div className="absolute bottom-0 p-[30px] sm:p-[16px] sm:pt-[40px] pt-[60px] flex  flex-col  justify-between left-0 w-full h-full">
                                        <div className="flex gap-x-[20px]">
                                            <img
                                                src={"/images/pharmacy/pharmaHouse/bioline.svg"}
                                                alt=""
                                                className="w-[70px] sm:w-[50px] h-[70px] sm:h-[50px]"
                                            />
                                            <img
                                                src={"/images/pharmacy/pharmaHouse/frezyderm.svg"}
                                                alt=""
                                                className="w-[70px] sm:w-[50px] h-[70px] sm:h-[50px]"
                                            />
                                        </div>
                                        <div>
                                            <h3
                                                className="text-[20px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px] leading-[30px] sm:leading-[18px] md:leading-[24px] lg:leading-[24px] xl:leading-[24px] font-semibold font-demi"
                                            >
                                                {"შამპუნები".toUpperCase()}
                                            </h3>
                                            <h3
                                                className="text-[20px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px] leading-[30px] sm:leading-[18px] md:leading-[24px] lg:leading-[24px] xl:leading-[24px] font-semibold font-demi"
                                            >
                                                {"ბალზამები".toUpperCase()}
                                            </h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="relative h-full sm:hidden max-h-[305px] w-[288px] sm:w-[168px] md:w-[210px] lg:w-[250px] xl:w-[270px] 2xl:w-[270px] mt-[150px]">
                                    <img
                                        src="/images/pharmacy/pharmaHouse/yellowRectangle3.png"
                                        alt=""
                                    />
                                    <div className="absolute bottom-0 p-[30px] sm:p-[16px] sm:pt-[40px] pt-[40px] flex  flex-col  justify-between left-0 w-full h-full">
                                        <div className="flex gap-x-[20px]">
                                            <img
                                                src={"/images/pharmacy/pharmaHouse/bioline.svg"}
                                                alt=""
                                                className="w-[70px] sm:w-[50px] h-[70px] sm:h-[50px]"
                                            />
                                            <img
                                                src={"/images/pharmacy/pharmaHouse/frezyderm.svg"}
                                                alt=""
                                                className="w-[70px] sm:w-[50px] h-[70px] sm:h-[50px]"
                                            />
                                        </div>
                                        <div>
                                            <h3
                                                className="text-[20px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px] leading-[30px] sm:leading-[18px] md:leading-[24px] lg:leading-[24px] xl:leading-[24px] font-semibold font-demi"
                                            >
                                                {"ნიღბები".toUpperCase()}
                                            </h3>
                                            <h3
                                                className="text-[20px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px] leading-[30px] sm:leading-[18px] md:leading-[24px] lg:leading-[24px] xl:leading-[24px] font-semibold font-demi"
                                            >
                                                {"კონდიციონერები".toUpperCase()}
                                            </h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="relative h-full max-h-[305px] w-[288px] sm:w-[168px] md:w-[210px] lg:w-[250px] xl:w-[270px] 2xl:w-[270px]">
                                    <img
                                        src="/images/pharmacy/pharmaHouse/yellowRectangle2.png"
                                        alt=""
                                    />
                                    <div className="absolute bottom-0 p-[30px] sm:p-[16px] sm:pt-[40px] pt-[60px] flex  flex-col  justify-between left-0 w-full h-full">
                                        <div className="flex gap-x-[20px]">
                                            <img
                                                src={"/images/pharmacy/pharmaHouse/bioline.svg"}
                                                alt=""
                                                className="w-[70px] sm:w-[50px] h-[70px] sm:h-[50px]"
                                            />
                                            <img
                                                src={"/images/pharmacy/pharmaHouse/frezyderm.svg"}
                                                alt=""
                                                className="w-[70px] sm:w-[50px] h-[70px] sm:h-[50px]"
                                            />
                                        </div>
                                        <div>
                                            <h3
                                                className="text-[20px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px] leading-[30px] sm:leading-[18px] md:leading-[24px] lg:leading-[24px] xl:leading-[24px] font-semibold font-demi"
                                            >
                                                {"ზეთი".toUpperCase()}
                                            </h3>
                                            <h3
                                                className="text-[20px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px] leading-[30px] sm:leading-[18px] md:leading-[24px] lg:leading-[24px] xl:leading-[24px] font-semibold font-demi"
                                            >
                                                {"შრატები".toUpperCase()}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="relative h-full hidden sm:block max-h-[305px] w-[288px] sm:w-[168px] md:w-[250px] lg:w-[250px] xl:w-[270px] 2xl:w-[270px]">
                                <img
                                    src="/images/pharmacy/pharmaHouse/yellowRectangle3.png"
                                    alt=""
                                />
                                <div className="absolute bottom-0 p-[30px] sm:p-[16px] sm:pt-[40px] pt-[60px] flex  flex-col  justify-between left-0 w-full h-full">
                                    <div className="flex gap-x-[20px]">
                                        <img
                                            src={"/images/pharmacy/pharmaHouse/bioline.svg"}
                                            alt=""
                                            className="w-[70px] sm:w-[50px] h-[70px] sm:h-[50px]"
                                        />
                                        <img
                                            src={"/images/pharmacy/pharmaHouse/frezyderm.svg"}
                                            alt=""
                                            className="w-[70px] sm:w-[50px] h-[70px] sm:h-[50px]"
                                        />
                                    </div>
                                    <div>
                                        <h3
                                            className="text-[20px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px] leading-[30px] sm:leading-[18px] md:leading-[24px] lg:leading-[24px] xl:leading-[24px] font-semibold font-demi"
                                        >
                                            {"ნიღბები".toUpperCase()}
                                        </h3>
                                        <h3
                                            className="text-[20px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px] leading-[30px] sm:leading-[18px] md:leading-[24px] lg:leading-[24px] xl:leading-[24px] font-semibold font-demi"
                                        >
                                            {"კონდიციონერები".toUpperCase()}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>

        </section>

        <section className="mt-[96px] sm:mt-[40px] pt-[72px] sm:pt-[40px] pb-[136px] sm:pb-[40px] bg-gray-30 xl:pb-[136px] 2xl:pb-[300px]">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="სხეულის მოვლის საშუალებები"
                    description="მუდმივმოქმედი, 35% ფასდაკლება მოცემული ბრენდების სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                    percentage={35}
                />
            </div>

            <div className="flex sm:block relative container px-[0px]">
                <img
                    src={"/images/pharmacy/pharmaHouse/bodyCareGreenBg.png"}
                    alt=""
                    className="xl:hidden sm:block sm:mb-[32px] ml-[-100px] sm:ml-0"
                />
                <div className={`absolute sm:static xl:static top-[50px] ml-0 ${width > 1280 && width < 1500 && "ml-[350px]"} ${width >=1500 && "!ml-[350px]"} ${width >= 1600 && "!ml-[400px]"} gap-x-[10px] grid grid-cols-4 gap-4 auto-rows-auto sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 lg:grid-cols-3 2xl:grid-cols-3 xl:justify-around md:w-full xl:w-full`}>
                    {bodyCareProducts.map(item => {
                        return(
                            <div
                                className={`
                                    ${width < 1281 && "!w-full"}
                                    ${item.id === 1 && "col-start-2 lg:col-start-1 xl:col-start-1"} bg-[#FFFFFF] rounded-[24px] p-[20px] w-full min-w-[260px] max-w-[292px] md:max-w-full 
                                    ${!!showAllBodyCareProds && item.id > 4 && "xl:hidden"}
                                    ${!!showAllBodyCareProds && item.id > 3 && "lg:hidden"}
                                    ${!!showAllBodyCareProds && item.id > 2 && "md:hidden"}
                                    ${!!showAllBodyCareProds && item.id > 1 && "sm:hidden"}
                                    `
                                }
                            >
                                <div className="flex gap-x-[12px]">
                                    {item.img1 && <img src={item.img1} alt="" className="w-[70px] h-[70px] border-[1px] border-[#070A141A] rounded-[100px]" />}
                                    {item.img2 && <img src={item.img2} alt="" className="w-[70px] h-[70px] border-[1px] border-[#070A141A] rounded-[100px]" />}
                                    {item.img3 && <img src={item.img3} alt="" className="w-[70px] h-[70px] border-[1px] border-[#070A141A] rounded-[100px]" />}
                                </div>
                                <div className="mt-[34px]">
                                    {item.title1 && <h3 className="flex flex-wrap max-w-[250px] text-[16px] font-semibold leading-[24px] font-demi">{item.title1.toUpperCase()}</h3>}
                                    {item.title2 && <h3 className="flex flex-wrap max-w-[250px] text-[16px] font-semibold leading-[24px] font-demi">{item.title2.toUpperCase()}</h3>}
                                    {item.title3 && <h3 className="flex flex-wrap max-w-[250px] text-[16px] font-semibold leading-[24px] font-demi">{item.title3.toUpperCase()}</h3>}
                                </div>
                            </div>
                        )
                    })}
                </div>
                
            </div>
            {width < 1281 && 
                <div className="flex justify-end sm:justify-center pr-[2.5%] sm:pr-0 w-full pt-[20px]">
                    <button
                        className="flex justify-center bg-raspberry-100 py-[10px] px-[20px] rounded-[12px] text-[#fff] font-semibold leading-[21px]"
                        onClick={() => setShowAllBodyCareProds((prev) => !prev)}
                    >
                        {!!showAllBodyCareProds ? "იხილე ყველა" : "იხილე ნაკლები"}
                    </button>
                </div>
            }
        </section>

        <section className="mt-[96px] sm:mt-[40px]">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="სამკურნალო საშუალებები"
                    description="მუდმივმოქმედი, 35% ფასდაკლება მოცემული ბრენდების სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                    percentage={35}
                />
                <div className="flex gap-[30px] sm:gap-[20px] md:gap-[20px] px-0 sm:px-[20px] xl:justify-between flex-wrap w-full">
                    {medicineCardsData.map(item => {
                        return(
                            <div key={item.id} className="bg-raspberry-10 flex min-w-[360px] max-w-[360px] xl:max-w-[48%] xl:min-w-[48%] sm:max-w-full sm:min-w-full md:max-w-[48%] md:min-w-[48%] md:w-full justify-between p-[6px] rounded-[12px]">
                                <h3 className="py-[24px] md:py-[4px] pl-[24px] md:pl-[4px] text-[14px] font-semibold leading-[21px] font-demi">{item.title.toUpperCase()}</h3>
                                <img src={item.img} alt={item.title} className="sm:max-w-[148px] md:max-w-[128px]" />
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>

        <section className="mt-[88px] sm:mt-[40px] relative">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="პირის ღრუს მოვლა"
                    description="მუდმივმოქმედი, 35% ფასდაკლება მოცემული ბრენდების სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                    percentage={35}
                />
            </div>

                <div className={`${width > 1280 && "container"} flex lg:flex-col items-center justify-between  mt-[148px] sm:mt-0 xl:mt-[96px]`}>

                    <img
                        src={"/images/pharmacy/pharmaHouse/teethBgMobile.png"}
                        alt=""
                        className="hidden sm:block w-full"
                    />
                    
                    <div className={`flex justify-between sm:justify-center w-[60%] px-0 md:px-0 lg:px-[2%] xl:px-0 lg:w-full xl:w-[70%] 2xl:w-[60%] sm:mt-[24px] ${width > 2000 && "w-[80%]"} ${width > 3200 && "w-full"}`}>

                        <div className="relative pt-[72px] pb-[40px] px-[32px] sm:pt-[40px] sm:pb-[24px] sm:px-[18px] w-[280px] min-w-[280px] max-w-[280px] sm:w-[168px] sm:min-w-[168px] sm:max-w-[168px] md:w-[220px] md:min-w-[220px] md:max-w-[220px] lg:w-[264px] lg:min-w-[264px] lg:max-w-[264 px] h-[268px] sm:h-[164px]">
                            <img
                                src={"/images/pharmacy/pharmaHouse/blueRectangle1.png"}
                                alt=""
                                className="absolute w-full h-full -z-10 top-0 left-0 border-[10px] border-[#fff]"
                            />
                            <div className="flex flex-col justify-between h-full">
                                <img
                                    src={"/images/pharmacy/pharmaHouse/freziDerm.svg"}
                                    alt=""
                                    className="w-[80px] h-[80px] sm:w-[50px] sm:h-[50px]"
                                />
                                <h3 className="text-[16px] leading-[24px] sm:text-[12px] sm:leading-[18px] font-semibold font-demi">{"სამკურნალო კბილის პასტები".toUpperCase()}</h3>
                            </div>
                        </div>

                        <div className="relative pt-[72px] pb-[40px] px-[32px] sm:pt-[40px] sm:pb-[24px] sm:px-[18px] w-[280px] min-w-[280px] max-w-[280px] sm:w-[168px] sm:min-w-[168px] sm:max-w-[168px] md:w-[220px] md:min-w-[220px] md:max-w-[220px] lg:w-[264px] lg:min-w-[264px] lg:max-w-[264px] h-[268px] sm:h-[164px]">
                            <img
                                src={"/images/pharmacy/pharmaHouse/blueRectangle2.png"}
                                alt=""
                                className="absolute w-full h-full -z-10 top-0 left-0 border-[10px] border-[#fff]"
                            />
                            <div className="flex flex-col justify-between h-full">
                                <img
                                    src={"/images/pharmacy/pharmaHouse/freziDerm.svg"}
                                    alt=""
                                    className="w-[80px] h-[80px] sm:w-[50px] sm:h-[50px]"
                                />
                                <h3 className="text-[16px] leading-[24px] sm:text-[12px] sm:leading-[18px] font-semibold font-demi">{"სავლები".toUpperCase()}</h3>
                            </div>
                        </div>

                        <div className="relative lg:hidden pt-[72px] pb-[40px] px-[32px] sm:pt-[40px] sm:pb-[24px] sm:px-[18px] w-[280px] min-w-[280px] max-w-[280px] sm:w-[168px] sm:min-w-[168px] sm:max-w-[168px] md:w-[220px] md:min-w-[220px] md:max-w-[220px] lg:w-[264px] lg:min-w-[264px] lg:max-w-[264px] h-[268px] sm:h-[164px]">
                            <img
                                src={"/images/pharmacy/pharmaHouse/blueReactangle.png"}
                                alt=""
                                className="absolute w-full h-full -z-10 top-0 left-0"
                            />
                            <div className="flex flex-col justify-between h-full">
                                <img
                                    src={"/images/pharmacy/pharmaHouse/freziDerm.svg"}
                                    alt=""
                                    className="w-[80px] h-[80px] sm:w-[50px] sm:h-[50px]"
                                />
                                <h3 className="text-[16px] leading-[24px] sm:text-[12px] sm:leading-[18px] font-semibold font-demi">{"კბილის პასტები".toUpperCase()}</h3>
                            </div>
                        </div>
                        
                    </div>

                    <div className={`relative hidden lg:block pt-[72px] pb-[40px] px-[32px] sm:pt-[40px] sm:pb-[24px] sm:px-[18px] w-[280px] min-w-[280px] max-w-[280px] sm:w-[168px] sm:min-w-[168px] sm:max-w-[168px] md:w-[220px] md:min-w-[220px] md:max-w-[220px] h-[268px] sm:h-[164px] lg:w-[264px] lg:min-w-[264px] lg:max-w-[264px] sm:mt-0 lg:mt-[-128px]`}>
                            <img
                                src={"/images/pharmacy/pharmaHouse/blueReactangle.png"}
                                alt=""
                                className="absolute w-full h-full -z-10 top-0 left-0"
                            />
                            <div className="flex flex-col justify-between h-full">
                                <img
                                    src={"/images/pharmacy/pharmaHouse/freziDerm.svg"}
                                    alt=""
                                    className="w-[80px] h-[80px] sm:w-[50px] sm:h-[50px]"
                                />
                                <h3 className="text-[16px] leading-[24px] sm:text-[12px] sm:leading-[18px] font-semibold font-demi">{"კბილის პასტები".toUpperCase()}</h3>
                            </div>
                    </div>

                    <div>
                        <img
                            src={width < 1537 ? "/images/pharmacy/pharmaHouse/croppedTeethBg.png" : "/images/pharmacy/pharmaHouse/girlTeeth.png"}
                            alt=""
                            className={`absolute lg:hidden right-0 top-[114px] -z-20 xl:w-[460px] 2xl:w-[660px] ${width > 2000 && "w-[800px]"} ${width > 2500 && "w-[1000px] top-[80px]"}`}
                        />
                    </div>
                </div>

        </section>

        <section className="mt-[96px] sm:mt-[40px]">
            <div className="container mt-3 sm:mt-2 md:mt-5 sm:px-[0] sm:w-full sm:max-w-full overflow-hidden">
                <TitleDescription
                    title="ჰიგიენური საშუალებები"
                    description="მუდმივმოქმედი, 35% ფასდაკლება მოცემული ბრენდების სრულ ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველდღე და ულიმიტოდ."
                    percentage={35}
                />

                {width > 756 ?
                    <div className="flex flex-col items-start justify-center">
                        <div className="grid justify-between w-full gap-[20px] grid-cols-7 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
                            {hygieneProductsData.map(item => {
                                return(
                                    <div className={`bg-[#EDB93733] lg:${!!showAllHygieneProds && item.id > 3 && "hidden"} xl:${!!showAllHygieneProds && item.id > 4 && "hidden"} 2xl:${!!showAllHygieneProds && item.id > 5 && "hidden"} p-[16px] rounded-[12px] w-[200px] ${width > 757 && "!w-full"} min-h-[200px] flex flex-col justify-between`}>
                                        <h3 className="text-primary text-[14px] font-semibold leading-[21px] font-demi">{item.title.toUpperCase()}</h3>
                                        <div className="flex flex-wrap mt-[12px] gap-[10px] items-bottom">
                                            {item.img1 &&
                                                <img
                                                    src={item.img1}
                                                    alt="img1"
                                                    className="w-[60px] h-[60px]"
                                                />
                                            }
                                            {item.img2 &&
                                                <img
                                                    src={item.img2}
                                                    alt="img2"
                                                    className="w-[60px] h-[60px]"
                                                />
                                            }
                                            {item.img3 &&
                                                <img
                                                    src={item.img3}
                                                    alt="img3"
                                                    className="w-[60px] h-[60px]"
                                                />
                                            }
                                            {item.img4 &&
                                                <img
                                                    src={item.img4}
                                                    alt="img4"
                                                    className="w-[60px] h-[60px]"
                                                />
                                            }
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {width < 1530 && 
                            <div className="flex justify-end w-full pt-[20px]">
                                <button
                                    className="flex justify-center bg-raspberry-100 py-[10px] px-[20px] rounded-[12px] text-[#fff] font-semibold leading-[21px]"
                                    onClick={() => setShowAllHygieneProds((prev) => !prev)}
                                >
                                    {!!showAllHygieneProds ? "იხილე ყველა" : "იხილე ნაკლები"}
                                </button>
                            </div>
                        }
                    </div>
                :
                    <div className="relative hidescroll overflow-x-auto mt-[40px] mb-[50px] flex gap-[12px] z-10 w-full">
                        <Swiper
                        modules={[Navigation]}
                        navigation
                        spaceBetween={12}
                        breakpoints={{
                            270: {
                                slidesPerView: 1.3,
                            },
                            340: {
                            slidesPerView: 1.5,
                            },
                            370: {
                            slidesPerView: 1.6,
                            },
                            400: {
                            slidesPerView: 1.8,
                            },
                            450: {
                                slidesPerView: 2.1,
                            },
                            560: {
                            slidesPerView: 2.5,
                            },
                            700: {
                            slidesPerView: 2.7,
                            },
                            832: {
                            slidesPerView: 3.3,
                            },
                            1080: {
                            slidesPerView: 4.5,
                            },
                            1280: {
                            slidesPerView: 5.5,
                            },
                            1527: {
                            slidesPerView: 6.5,
                            },
                        }}
                        className={`${
                            width > 1527 ? "" : "pr-5 pl-5 sm:pr-4 sm:pl-4"
                        } md:px-[32px] w-full`}
                        >
                        {hygieneProductsData.map(item => {
                            return(
                            <SwiperSlide>
                                <div className={`bg-[#EDB93733] p-[16px] rounded-[12px] w-[200px] min-h-[200px] flex flex-col justify-between`}>
                                    <h3 className="text-primary text-[14px] font-semibold leading-[21px] font-demi">{item.title.toUpperCase()}</h3>
                                    <div className={`flex flex-wrap mt-[12px] gap-[10px] items-bottom`}>
                                    {item.img1 &&
                                            <img
                                                src={item.img1}
                                                alt="img1"
                                                className={`${item.id === 9 ? "w-[48px] h-[48px]" : "w-[60px] h-[60px]"}`}
                                            />
                                        }
                                        {item.img2 &&
                                            <img
                                                src={item.img2}
                                                alt="img2"
                                                className={`${item.id === 9 ? "w-[48px] h-[48px]" : "w-[60px] h-[60px]"}`}
                                            />
                                        }
                                        {item.img3 &&
                                            <img
                                                src={item.img3}
                                                alt="img3"
                                                className={`${item.id === 9 ? "w-[48px] h-[48px]" : "w-[60px] h-[60px]"}`}
                                            />
                                        }
                                        {item.img4 &&
                                            <img
                                                src={item.img4}
                                                alt="img4"
                                                className={`${item.id === 9 ? "w-[48px] h-[48px]" : "w-[60px] h-[60px]"}`}
                                            />
                                        }
                                    </div>
                                </div>
                            </SwiperSlide>
                                
                            )
                        })}
                        </Swiper>
                    </div>
                }
                
            </div>
        </section>

        <div className="container mb-[80px] sm:mb-[16px] mt-[16px] sm:mt-[4px] h-[281px] mt-[48px] sm:h-[316px] mb-[32px] sm:mx-[16px] relative rounded-[16px] overflow-hidden">
        {width > 640 ? (
          <img
            className="object-cover object-left w-full h-full"
            src="/images/pharmacy/pharmaHouse/vitaBanner.png"
            alt=""
          />
        ) : (
          <img
            className="max-h-[316px] w-full"
            src="/images/pharmacy/pharmaHouse/vitaBannerMobile.png"
            alt=""
          />
        )}
        <div className="absolute sm:w-[90%] left-[50%] translate-x-[-50%] top-[50%] translate-y-[-50%] flex flex-col gap-8 items-center">
          <span className="font-demi text-[24px] text-[#070A14] leading-[45px] sm:text-[14px] md:text-[18px] sm:leading-[27px] md:leading-[36px] text-center">
            ხელმისაწვდომი სერვისებით და პროდუქტებით სარგებლობისთვის გახდი VITA ბარათის მფლობელი
          </span>
          {error?.isAuthorized ? (
            <Link to="/checkout">
              <button className="py-[20px] text-nowrap px-[40px] text-blackPrimary-100 font-demi text-rg rounded-[12px] bg-[#fff]">
                ბარათის ყიდვა
              </button>
            </Link>
          ) : (
            <a href="/secured">
              <button className="py-[20px] text-nowrap px-[40px] text-blackPrimary-100 font-demi text-rg rounded-[12px] bg-[#fff]">
                ბარათის ყიდვა
              </button>
            </a>
          )}
        </div>
      </div>
    
    </div>
  );
  
};
